import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from '../../context/ThemeContext';
import { Box, IconButton, MenuItem, MenuList, Popover, TextField } from '@mui/material';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import CheckIcon from "@mui/icons-material/Check"

function HistoryFooter({ selectedType, sortedHistory, totalProfitLoss, searchQuery, setSearchQuery, anchorEl, handleToggleSearchBar, handleCloseFilterMenu, uniqueSymbols, handleSelectSymbol, setAnchorEl, selectedSymbol }) {
    const { t } = useTranslation()
    const { darkMode } = useContext(ThemeContext)

    const formatAmount = (value) => {
        if (isNaN(value)) return "0.00";
        return Number(value).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    const deposit = selectedType === "Transaction" ? sortedHistory.filter(row => row.type === 1).reduce((total, row) => total + (row.amount || 0), 0) : 0;
    const creditOut = selectedType === "Transaction" ? sortedHistory.filter(row => row.type === 5).reduce((total, row) => total + (row.amount || 0), 0) : 0;
    const creditIn = selectedType === "Transaction" ? sortedHistory.filter(row => row.type === 3).reduce((total, row) => total + (row.amount || 0), 0) : 0;
    const adjustment = selectedType === "Transaction" ? sortedHistory.filter(row => row.type === 2).reduce((total, row) => total + (row.amount || 0), 0) : 0;
    const withdrawal = selectedType === "Transaction" ? sortedHistory.filter(row => row.type === 4).reduce((total, row) => total + (row.amount || 0), 0) : 0;
    const total = parseFloat((deposit + creditIn + creditOut + adjustment + withdrawal))

    return (
        <>
            <Box display='flex' justifyContent='space-between' alignItems='center' sx={{ mx: 1 }}>
                <div style={{ marginTop: 3, }}>
                    <IconButton onClick={(e) => anchorEl ? handleCloseFilterMenu() : e.currentTarget && anchorEl === null && setAnchorEl(e.currentTarget)} sx={{ border: `1px solid #2e3338`, borderRadius: '3px', padding: '6px', marginRight: '6px', height: 30 }}>
                        <CurrencyExchangeIcon sx={{ fontSize: 16, color: darkMode ? '#fff' : '#000' }} />
                    </IconButton>
                    <TextField size="small" variant="outlined" placeholder={t("mobSearch")} value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} sx={{ flex: 1, width: '250px' }} InputProps={{ sx: { fontSize: 13, padding: 0, height: 30, "& input": { padding: "0", paddingLeft: 1, height: "30px", }, }, }} />

                    <Popover open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={handleCloseFilterMenu} anchorOrigin={{ vertical: "top", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}>
                        <MenuList sx={{ backgroundColor: darkMode ? "#202933" : "#fff", }}>
                            {uniqueSymbols?.length > 0 && (
                                <MenuItem onClick={() => handleSelectSymbol("All")} sx={{ fontSize: 13.5, }}>{t('allSymbols')}</MenuItem>
                            )}
                            {uniqueSymbols.length > 0 ? uniqueSymbols.map((symbol, index) => (
                                <MenuItem key={index} onClick={() => handleSelectSymbol(symbol)} sx={{ fontSize: 13.5, display: "flex", justifyContent: "space-between" }}>{symbol}{selectedSymbol === symbol && <CheckIcon fontSize="small" sx={{ fontSize: 18, color: "#4597ff" }} />}</MenuItem>
                            )) : (<MenuItem disabled sx={{ fontSize: 13.5 }}>{t('NoSymbolsAvailable')}</MenuItem>)}
                        </MenuList>
                    </Popover>
                </div>
                <div className='flex h-full items-center' style={{ backgroundColor: darkMode ? "#151924" : "#fff", color: darkMode ? 'var(--lightText)' : 'var(--darkText)' }}>
                    <div className='text-sm mx-2 ms-5 '>{t('totalAmount')}: {total ? formatAmount(total) : '0.00'}</div>
                    <div className='text-sm mx-2 ms-5 '>{t('profit')}: {(totalProfitLoss)?.toFixed(2) || "0.00"}</div>
                    <div className='text-sm mx-2 '>{t('deposit')}: {deposit ? formatAmount(deposit) : '0.00'}</div>
                    <div className='text-sm mx-2 '>{t("withdrawal")}: {withdrawal ? formatAmount(withdrawal) : '0.00'}</div>
                    <div className='text-sm mx-2 '>{t('adjustment')}: {adjustment ? formatAmount(adjustment) : '0.00'}</div>
                    <div className='text-sm mx-2 '>{t("creditIn")}: {creditIn ? formatAmount(creditIn) : '0.00'}</div>
                    <div className='text-sm mx-2 '>{t('creditOut')}: {creditOut ? formatAmount(creditOut) : '0.00'}</div>
                </div>


            </Box>

        </>
    );
}

export default HistoryFooter;
